/*
 * � 2020 Microsoft. All rights reserved.
 */

define('SolitaireShared/CardLogic/MoveState',{
	CanMove: 0, 
	CanDealNextDeck: 1, 
	NoMovesLeft: 2
});
